import {configureStore} from '@reduxjs/toolkit'
import cardReducer from "../reducers/cardReducer";
import printReducer from "../reducers/printReducer";
import offersReducer from "../reducers/offersReducer";
import labelReducer from "../reducers/labelReducer";
import userReducer from "../reducers/userReducer";
import collectionReducer from "../reducers/collectionReducer";
import controlsReducer from "../reducers/controlsReducer";
import alertReducer from "../reducers/alertReducer";

export default configureStore({
    reducer: {
        cardReducer,
        printReducer,
        labelReducer,
        userReducer,
        collectionReducer,
        controlsReducer,
        offersReducer,
        alertReducer,
    },
})
